import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import equals from 'validator/lib/equals';
import isStrongPassword from 'validator/lib/isStrongPassword';
import { ValidationError, ValidationErrors } from './validationError';

export const notAllowed = (value: string | number, patterns: string[], field: string) => {
  if (patterns.some(pattern => equals(value.toString(), pattern))) {
    const e: ValidationError = { field, type: 'notAllowed', parameters: [] };
    return [e];
  }

  return [];
};

export const email = (value: string, field: string): ValidationErrors => {
  // we need to check the value because the required logic already separated
  if (value && !isEmail(value)) {
    const e: ValidationError = { field, type: 'email', parameters: [] };
    return [e];
  }
  return [];
};

export const phone = (value: string, field: string): ValidationErrors => {
  // we cannot use validator.isMobilePhone here, because it is too strict.
  // therefore we use weak validation as on BE
  if (value && !/^\+([0-9]){8,16}$/.test(value)) {
    const e: ValidationError = { field, type: 'phone', parameters: [] };
    return [e];
  }
  return [];
};

export const password = (value: string, field: string): ValidationErrors => {
  const options = { minLength: 8, minNumbers: 1, minUppercase: 1, minLowercase: 1, minSymbols: 1 };

  if (value && !isStrongPassword(value.trim(), options)) {
    const e: ValidationError = { field, type: 'strongPassword', parameters: [] };
    return [e];
  }

  return [];
};

export const loginPassword = (value: string, field: string): ValidationErrors => {
  const minLength = 6;
  // we need to check the value because the required logic already separated
  if (value && value.trim().length < minLength) {
    const e: ValidationError = { field, type: 'stringMin', parameters: [minLength.toString()] };
    return [e];
  }

  return [];
};

export const required = (value: string | unknown[], field: string): ValidationErrors => {
  if (typeof value === 'string') {
    if (isEmpty(value, { ignore_whitespace: true })) {
      const e: ValidationError = { field, type: 'required', parameters: [] };
      return [e];
    }
  } else if (!value || value.length < 1) {
    const e: ValidationError = { field, type: 'required', parameters: [] };
    return [e];
  }

  return [];
};

export const confirmed = (value: string, valueToMatch: string, field: string): ValidationErrors => {
  if (value !== valueToMatch) {
    const e: ValidationError = { field, type: 'confirmed', parameters: [] };
    return [e];
  }
  return [];
};

export const number = (value: string, isFloat: boolean, field: string): ValidationErrors => {
  const regExp = isFloat ? /^\d+(\.\d+)?$/ : /^\d+$/;

  // we need to check the value because the required logic already separated
  if (value && !regExp.test(value)) {
    const e: ValidationError = { field, type: 'number', parameters: [] };
    return [e];
  }
  return [];
};

export const numberMin = (value: string, minValue: number, field: string): ValidationErrors => {
  const n = parseFloat(value);

  if (Number.isNaN(n)) {
    return [];
  }

  if (n < minValue) {
    const e: ValidationError = { field, type: 'numberMin', parameters: [minValue.toString()] };
    return [e];
  }

  return [];
};

export const numberMax = (value: string, maxValue: number, field: string): ValidationErrors => {
  const n = parseFloat(value);

  if (Number.isNaN(n)) {
    return [];
  }

  if (n > maxValue) {
    const e: ValidationError = { field, type: 'numberMax', parameters: [maxValue.toString()] };
    return [e];
  }

  return [];
};
